import React from "react";
import { Doughnut } from "react-chartjs-2";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import moment from "moment";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import "../GoalsDashboard/GoalsDashboard.css";

export const GoalsDetails = ({ data, keyIndex, deleteGoal, taxInfo }) => {
  const history = useHistory();
  const safeData = data || {};
  const parseAmount = (value) => {
    const parsedValue = parseFloat(value);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };
  
  const centerTextPlugin = {
    id: "centerText",
    afterDraw: (chart) => {
      const { ctx, width, height } = chart;
      const text = chart.config.data.text;

      if (!text) return; // Skip if text is empty

      // Save context state (do NOT clear the chart)
      ctx.save();

      const sidePadding = 20;
      const sidePaddingCalculated =
        (sidePadding / 100) * (chart.innerRadius * 2);
      const stringWidth = ctx.measureText(text).width;
      const elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;
      const widthRatio = elementWidth / stringWidth;
      const newFontSize = Math.floor(30 * widthRatio);
      const elementHeight = chart.innerRadius * 2;
      const fontSizeToUse = Math.min(newFontSize, elementHeight);

      const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

      ctx.font = `20px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw text on top of the chart
      ctx.fillText(text, centerX, centerY);

      ctx.restore();
    },
  };

  function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  };
  const calculateGoalNeed = (amountNeed, date, inflation) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const goalInflation = inflation && inflation;
    const matchedInflation =
      taxInfo && taxInfo.find((item) => item.name === goalInflation);
    const GoalInflationRate = matchedInflation
      ? (parseFloat(matchedInflation.value) || 0) / 100
      : 0;
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    const NumberofYears = NumberofMonths / 12;
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const n = 12;
    const result =
      GoalNeedToday * Math.pow(1 + GoalInflationRate / n, n * NumberofYears);
    // const result =
    //   GoalNeedToday *
    //   Math.pow(
    //     1 + GoalInflationRate / 100 / 365,
    //     365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
    //       NumberofMonths
    //   );
    console.log("result", result);
    return parseFloat(result).toFixed(2);
  };
  const goalNeed = safeData["Dollar Amount Needed"]
    ? parseFloat(
        calculateGoalNeed(
          safeData["Dollar Amount Needed"],
          safeData["Goal Date"] ? safeData["Goal Date"] : new Date(),
          safeData["Inflation rate for this goal"] &&
            safeData["Inflation rate for this goal"]
        )
      ) || 0
    : 0;
  const totalHave =
    (safeData.assignAssets && Array.isArray(safeData.assignAssets)
      ? safeData.assignAssets.reduce(
          (acc, curr) => acc + parseAmount(curr && curr.amountUseForGoal),
          0
        )
      : 0) +
    (safeData["Total Monthly Saving for All Goals"]
      ? parseAmount(safeData["Total Monthly Saving for All Goals"])
      : 0) +
    (safeData["Amount Received"] && Array.isArray(safeData["Amount Received"])
      ? safeData["Amount Received"].reduce(
          (acc, curr) => acc + parseAmount(curr || 0),
          0
        )
      : 0);
  const cappedHave = goalNeed > 0 ? Math.min(totalHave, goalNeed) : totalHave;
  const incompletePercentage =
    goalNeed > 0 ? Math.max(100 - (cappedHave / goalNeed) * 100, 0) : 0;
  const completePercentage =
    goalNeed > 0 ? Math.min((cappedHave / goalNeed) * 100, 100) : 0;
  const labels = [
    `Need: $${goalNeed
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    `Have: $${cappedHave
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
  ];
  const dataValues = [
    parseFloat(incompletePercentage.toFixed(2)),
    parseFloat(completePercentage.toFixed(2)),
  ];
  return (
    <React.Fragment>
      <div className="GoalCard3">
        <h1 className="GoalsCardheading">
          {safeData["Description of Goal"]
            ? safeData["Description of Goal"]
            : "N/A"}
        </h1>
        <Doughnut
          data={{
            labels: labels && labels,
            datasets: [
              {
                label: "Goal Value",
                data: dataValues && dataValues,
                // backgroundColor: chartColors,
                backgroundColor: ["#2A3DA3", "#09A84D"],
              },
            ],
            // text: `${
            //     data &&
            //     data.assignAssets &&
            //     data["Dollar Amount Needed"]
            //       ? Math.min(
            //           ((data.assignAssets && Array.isArray(data.assignAssets)
            //             ? data.assignAssets.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0):0) / calculateGoalNeed(data["Dollar Amount Needed"] ,data["Goal Date"] ? data["Goal Date"] : new Date())) * 100,
            //           100
            //         ).toFixed(2) + "%"
            //       : "0.0%" // Fallback to 0% if the values are not present
            //   }`,
            text: `${
              safeData["Dollar Amount Needed"]
                ? completePercentage.toFixed(2) + "%"
                : "0.0%" // Fallback to 0% if the values are not present
            }`,
            // text: `${
            //   data &&
            //   data["Amount to use for this goal"] &&
            //   data["Dollar Amount Needed"]
            //     ? (((Array.isArray(data["Amount to use for this goal"]) ? data["Amount to use for this goal"].reduce((acc, curr) => acc + curr, 0) : 0 )/data["Dollar Amount Needed"])* 100).toFixed(2) + "%"
            //     : "0%"  // Fallback to 0% if the values are not present
            // }`,
          }}
          options={{
            // cutoutPercentage: 70,
            responsive: true,
            legend: {
              display: true,
              position: "right",
            },
          }}
          plugins={[centerTextPlugin]}
        />
      </div>
      <div className="goalCard2 goalDetailsCard">
        <div className="goalDetailsHeader">
          <h1 className="GoalsCardheading">Goal Details</h1>
          <div className="goalDetailsMenu">
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        if (safeData.module && safeData.id) {
                          history.push(
                            `/goals_add/attributes/${safeData.module}/${safeData.id}/view`
                          );
                        }
                      }}
                    >
                      View
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        if (safeData.module && safeData.id) {
                          history.push(
                            `/goals_add/attributes/${safeData.module}/${safeData.id}`
                          );
                        }
                      }}
                    >
                      Update
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        if (safeData.id && deleteGoal) {
                          deleteGoal(safeData.id, safeData);
                        }
                      }}
                    >
                      Delete
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link goalDetailsMenuTrigger"
                onClick={(e) => e.preventDefault()}
              >
                <img src={menuIcon} height={15} width={4} alt="icon"></img>
              </a>
            </Dropdown>{" "}
          </div>
        </div>
        <div className="goalDetailsBody">
          <div className="goalDetailsGrid">
            <div className="goalDetailsItem goalDetailsItemAccent">
              <span className="goalDetailsLabel">Amount Needed</span>
              <span className="goalDetailsValue goalDetailsValueAmount">
                  $
                  {(() => {
                    const amountNeeded = Math.max(goalNeed - totalHave, 0);

                    return amountNeeded
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  })()}
              </span>
            </div>
            <div className="goalDetailsItem goalDetailsItemWide">
              <span className="goalDetailsLabel">Asset Assign to Goal</span>
              <span className="goalDetailsValue goalDetailsAssetsValue">
                  {
                    safeData.assignAssets &&
                    Array.isArray(safeData.assignAssets)
                      ? safeData.assignAssets.map((item, index) => (
                          <span key={index} className="goalDetailsAssetTag">
                            {index + 1} {item.asset}
                          </span>
                        ))
                      : safeData.assignAssets
                      ? safeData.assignAssets
                      : "N/A"
                  }
              </span>
            </div>
            <div className="goalDetailsItem">
              <span className="goalDetailsLabel">Goals Date</span>
              <span className="goalDetailsValue">
                  {`${
                    safeData["Goal Date"]
                      ? moment(safeData["Goal Date"]).format("MM/DD/YYYY")
                      : "N/A"
                  }`}
              </span>
            </div>
            <div className="goalDetailsItem">
              <span className="goalDetailsLabel">Inflation Rate</span>
              <span className="goalDetailsValue">
                  {" "}
                  {safeData["Inflation rate for this goal"]
                    ? safeData["Inflation rate for this goal"]
                    : 0}
              </span>
            </div>
          </div>
        </div>
        {/* <NewLoader isLoading={loading} /> */}
      </div>
    </React.Fragment>
  );
};
